import { render, staticRenderFns } from "./ComboboxTaskType.vue?vue&type=template&id=fbf8e07c&scoped=true&"
import script from "./ComboboxTaskType.vue?vue&type=script&lang=js&"
export * from "./ComboboxTaskType.vue?vue&type=script&lang=js&"
import style0 from "./ComboboxTaskType.vue?vue&type=style&index=0&id=fbf8e07c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf8e07c",
  null
  
)

export default component.exports